import Vue from "vue";
import Vuetify from "vuetify/lib";
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: "#757575",
        primary: "#212121",
        secondary: "#EE7975",
        accent: "#3FA198",
        error: "#b71c1c",
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
});

// #68EDE2
